import { cva } from 'class-variance-authority';

export const main = cva([
  'sm:min-w-[384px]',
  'flex',
  'flex-col',
  'gap-2',
  'justify-center',
  'items-center',
  'font-inter',
  'h-full',
  'overflow-y-auto',
  'p-6',
]);

export const loadingContainer = cva([
  'flex',
  'flex-col',
  'items-center',
  'gap-6',
  'text-center',
]);

export const spinner = cva([
  'w-8',
  'h-8',
  'border-4',
  'border-neutral-200',
  'border-t-brand-pure',
  'rounded-full',
  'animate-spin',
]);

export const loadingText = cva([
  'text-2xl',
  'font-semibold',
  'text-neutral-900',
  'font-inter',
]);

export const loadingSubtext = cva([
  'text-lg',
  'font-light',
  'text-neutral-700',
  'font-inter',
]);
